"use strict";
/// <reference lib="dom" />
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetch = exports.retryFetch = void 0;
const index_1 = require("./index");
const cross_fetch_1 = __importDefault(require("cross-fetch"));
// 408 is timeout
// 429 is too many requests
// 424 is failed dependency
// 499 is client closed connection
// 444 is connection closed without response
// 502 is Bad gateway
// 503 is Service Unavailable
// 504 is Gateway Timeout
// 599 is Network Connect Timeout Error
const ERROR_CODES_TO_RETRY = new Set([
    408, 429, 424, 499, 444, 502, 503, 504, 599,
]);
function isRetryableStatus(errorcode) {
    return ERROR_CODES_TO_RETRY.has(errorcode);
}
/**
 * Fetches a resource using the provided config and retries if it fails with a network or server availability error
 *
 * @param {RequestInfo} input: request info for fetch
 * @param {RequestInit} init: request options for fetch
 * @param {pRetry.PromiseRetryOptions} retryOptions: Retry configuration
 * @returns {Response}
 */
function retryFetch(input, init, retryOptions = {}) {
    const tryFetch = async () => {
        const response = await (0, cross_fetch_1.default)(input, init);
        if (!response.ok && isRetryableStatus(response.status)) {
            throw new index_1.pRetry.AbortError(`[${response.status}]: ${response.statusText}`);
        }
        return response;
    };
    return index_1.pRetry.run(tryFetch, retryOptions);
}
exports.retryFetch = retryFetch;
var cross_fetch_2 = require("cross-fetch");
Object.defineProperty(exports, "fetch", { enumerable: true, get: function () { return cross_fetch_2.fetch; } });
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmV0Y2guanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvZmV0Y2gudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLDJCQUEyQjs7Ozs7O0FBRTNCLG1DQUFpQztBQUNqQyw4REFBZ0M7QUFFaEMsaUJBQWlCO0FBQ2pCLDJCQUEyQjtBQUMzQiwyQkFBMkI7QUFDM0Isa0NBQWtDO0FBQ2xDLDRDQUE0QztBQUM1QyxxQkFBcUI7QUFDckIsNkJBQTZCO0FBQzdCLHlCQUF5QjtBQUN6Qix1Q0FBdUM7QUFDdkMsTUFBTSxvQkFBb0IsR0FBRyxJQUFJLEdBQUcsQ0FBQztJQUNuQyxHQUFHLEVBQUUsR0FBRyxFQUFFLEdBQUcsRUFBRSxHQUFHLEVBQUUsR0FBRyxFQUFFLEdBQUcsRUFBRSxHQUFHLEVBQUUsR0FBRyxFQUFFLEdBQUc7Q0FDNUMsQ0FBQyxDQUFDO0FBQ0gsU0FBUyxpQkFBaUIsQ0FBQyxTQUFpQjtJQUMxQyxPQUFPLG9CQUFvQixDQUFDLEdBQUcsQ0FBQyxTQUFTLENBQUMsQ0FBQztBQUM3QyxDQUFDO0FBRUQ7Ozs7Ozs7R0FPRztBQUNILFNBQWdCLFVBQVUsQ0FDeEIsS0FBa0IsRUFDbEIsSUFBa0IsRUFDbEIsZUFBMkMsRUFBRTtJQUU3QyxNQUFNLFFBQVEsR0FBRyxLQUFLLElBQUksRUFBRTtRQUMxQixNQUFNLFFBQVEsR0FBRyxNQUFNLElBQUEscUJBQUssRUFBQyxLQUFLLEVBQUUsSUFBSSxDQUFDLENBQUM7UUFDMUMsSUFBSSxDQUFDLFFBQVEsQ0FBQyxFQUFFLElBQUksaUJBQWlCLENBQUMsUUFBUSxDQUFDLE1BQU0sQ0FBQyxFQUFFLENBQUM7WUFDdkQsTUFBTSxJQUFJLGNBQU0sQ0FBQyxVQUFVLENBQ3pCLElBQUksUUFBUSxDQUFDLE1BQU0sTUFBTSxRQUFRLENBQUMsVUFBVSxFQUFFLENBQy9DLENBQUM7UUFDSixDQUFDO1FBQ0QsT0FBTyxRQUFRLENBQUM7SUFDbEIsQ0FBQyxDQUFDO0lBQ0YsT0FBTyxjQUFNLENBQUMsR0FBRyxDQUFXLFFBQVEsRUFBRSxZQUFZLENBQUMsQ0FBQztBQUN0RCxDQUFDO0FBZkQsZ0NBZUM7QUFFRCwyQ0FBb0M7QUFBM0Isb0dBQUEsS0FBSyxPQUFBIn0=